import { clientUrls } from "misc/urls/clientUrls";
import { UserManagementRoles } from "misc/roles";

export const standardSidebarItems = [
    {
        title: "t_roles",
        key: "roles",
        url: clientUrls.roles.baseUrl(),
        allowed: [UserManagementRoles.PermissionAuthorityFull],
        icon: "layer-group"
    },
    {
        title: "t_customers",
        key: "customers",
        url: clientUrls.customers.baseUrl(),
        allowed: [UserManagementRoles.PermissionAuthorityFull],
        icon: "buildings"
    },
    {
        title: "t_users",
        key: "users",
        url: clientUrls.users.baseUrl(),
        allowed: [UserManagementRoles.PermissionAuthorityFull, UserManagementRoles.PermissionAuthorityLocalAdmin],
        icon: "users"
    }
];
export const getSidebarItems = () => {
    const location = window.location.pathname;
    return standardSidebarItems;
};
